import { useCallback } from 'react'
import { useBsvExchangeRate } from 'api/useBsvExchangeRate'
import { formatDailyMoney } from './dailyMoney'

// The daily money rule against the live exchange rate (see dailyMoney.ts).
export default function useDailyMoney({ enabled = true }: { enabled?: boolean } = {}) {
    const exchangeRate = useBsvExchangeRate({ enabled })
    return useCallback(
        (sats: number | string | null | undefined) => formatDailyMoney(sats, exchangeRate),
        [exchangeRate],
    )
}
